import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TitledPageComponent } from 'src/app/shared/components/titled-page/titled-page.component';

@Component({
  selector: 'app-spares-requests',
  standalone: true,
  imports: [CommonModule, RouterOutlet, TitledPageComponent],
  templateUrl: './spares-requests.component.html',
  styleUrl: './spares-requests.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SparesRequestsComponent {}
